// extracted by mini-css-extract-plugin
module.exports = {"root":"price_root__2t8Zv","aligncenter":"price_aligncenter__64_T9"};